class ZebaSizeGuide extends HTMLElement {
  connectedCallback() {
    this.chartDialog = this.querySelector('[data-zeba-size-chart]');
    this.quizDialog = this.querySelector('[data-zeba-size-quiz]');
    this.openChartBtn = this.querySelector('[data-zeba-open-chart]');
    this.openQuizBtns = this.querySelectorAll('[data-zeba-open-quiz]');
    this.closeBtns = this.querySelectorAll('[data-zeba-close]');
    this.disclaimer = this.getAttribute('data-disclaimer') || '';
    this.sizeOrder = (this.getAttribute('data-size-order') || '')
      .split(',')
      .map((value) => value.trim())
      .filter(Boolean);

    this.track = this.querySelector('[data-zeba-quiz-track]');
    this.steps = Array.from(this.querySelectorAll('[data-zeba-quiz-step]'));
    this.progressLabel = this.querySelector('[data-zeba-quiz-progress]');
    this.progressBar = this.querySelector('[data-zeba-quiz-progress-bar]');
    this.resultEl = this.querySelector('[data-zeba-quiz-result]');
    this.heightInput = this.querySelector('[data-zeba-quiz-height]');

    this.answers = {};
    this.currentStep = 1;
    this.totalSteps = this.steps.length || 5;

    this.openChartBtn?.addEventListener('click', () => {
      if (typeof this.chartDialog?.showModal === 'function') this.chartDialog.showModal();
    });

    this.openQuizBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.chartDialog?.close();
        this.resetQuiz();
        if (typeof this.quizDialog?.showModal === 'function') this.quizDialog.showModal();
      });
    });

    this.closeBtns.forEach((btn) => {
      btn.addEventListener('click', () => btn.closest('dialog')?.close());
    });

    this.querySelector('[data-zeba-quiz-next-height]')?.addEventListener('click', () => {
      this.answers.height = this.heightInput ? this.heightInput.value : '';
      this.goToStep(2);
    });

    this.querySelectorAll('[data-zeba-quiz-back]').forEach((btn) => {
      btn.addEventListener('click', () => this.goToStep(this.currentStep - 1));
    });

    this.querySelectorAll('[data-zeba-quiz-option]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const field = btn.dataset.field;
        const group = btn.closest('[data-zeba-quiz-step]');
        group?.querySelectorAll('[data-zeba-quiz-option]').forEach((other) => other.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        this.answers[field] = btn.dataset.value;

        if (field === 'usual_size') {
          this.computeAdvice();
          window.setTimeout(() => this.goToStep(5), 150);
        } else {
          window.setTimeout(() => this.goToStep(this.currentStep + 1), 150);
        }
      });
    });

    this.querySelector('[data-zeba-quiz-restart]')?.addEventListener('click', () => this.resetQuiz());

    this.quizDialog?.addEventListener('close', () => this.resetQuiz());
  }

  resetQuiz() {
    this.answers = {};
    if (this.heightInput) this.heightInput.value = '';
    this.querySelectorAll('[data-zeba-quiz-option].is-selected').forEach((btn) => btn.classList.remove('is-selected'));
    if (this.resultEl) this.resultEl.innerHTML = '';
    this.goToStep(1, true);
  }

  goToStep(targetStep, instant) {
    this.currentStep = Math.max(1, Math.min(this.totalSteps, targetStep));

    if (this.track) {
      if (instant) {
        this.track.style.transition = 'none';
        this.track.style.transform = `translateX(-${(this.currentStep - 1) * 100}%)`;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.track.style.transition = '';
          });
        });
      } else {
        this.track.style.transform = `translateX(-${(this.currentStep - 1) * 100}%)`;
      }
    }

    const shownStep = Math.min(this.currentStep, 4);
    if (this.progressLabel) {
      this.progressLabel.textContent = this.currentStep <= 4 ? `Stap ${shownStep} van 4` : 'Jouw resultaat';
    }
    if (this.progressBar) {
      const pct = (shownStep / 4) * 100;
      this.progressBar.style.width = `${pct}%`;
    }

    const activeStep = this.steps[this.currentStep - 1];
    const focusTarget = activeStep?.querySelector('input, button');
    if (focusTarget) {
      window.setTimeout(() => focusTarget.focus({ preventScroll: true }), 300);
    }
  }

  computeAdvice() {
    const usualSize = this.answers.usual_size;
    const build = this.answers.build;
    const drape = this.answers.drape;
    const height = parseInt(this.answers.height, 10);

    const currentIndex = this.sizeOrder.indexOf(usualSize);
    let shift = 0;
    if (build === 'slim') shift -= 1;
    if (build === 'wide') shift += 1;
    if (drape === 'tight') shift -= 1;
    if (drape === 'loose') shift += 1;

    let advice = usualSize;
    if (currentIndex > -1) {
      const newIndex = Math.min(Math.max(currentIndex + shift, 0), this.sizeOrder.length - 1);
      advice = this.sizeOrder[newIndex];
    }

    let lengthTip = '';
    if (!Number.isNaN(height)) {
      if (height < 160) {
        lengthTip = ' Bij jouw lengte kunnen items iets lang uitvallen — check de lengtematen in de maattabel.';
      } else if (height > 178) {
        lengthTip = ' Bij jouw lengte kunnen items iets korter uitvallen — check de lengtematen in de maattabel.';
      }
    }

    if (!this.resultEl) return;
    this.resultEl.innerHTML = '';

    const adviceLine = document.createElement('p');
    const strong = document.createElement('strong');
    strong.textContent = `Maatadvies: ${advice}`;
    adviceLine.appendChild(strong);

    const disclaimerLine = document.createElement('p');
    disclaimerLine.textContent = `${this.disclaimer}${lengthTip}`;

    this.resultEl.append(adviceLine, disclaimerLine);
  }
}

if (!customElements.get('zeba-size-guide')) {
  customElements.define('zeba-size-guide', ZebaSizeGuide);
}
